import { ReactElement } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { pushClickSessionCta } from "../../../../utils/gtm";
import arrow from "../../../assets/arrow.svg";
import { Wrapper } from "../wrapper/wrapper";
import { AboutMoreProps } from "./about-props";
import * as S from "./about-style";

export function AboutMore({
  id,
  name,
  ...props
}: AboutMoreProps): ReactElement {
  const handleCtaClick = (): void => pushClickSessionCta(name);
  return (
    <S.Container id={id}>
      <S.BannerContainer>
        <Wrapper>
          <S.BannerWrapper>
            <S.BannerContent>
              <S.Title>{props.values.title}</S.Title>
              <S.Description
                dangerouslySetInnerHTML={{ __html: props.values.subtitle }}
              />
            </S.BannerContent>
            <S.Divs>
              {props.values.cards.map((card, index) => (
                <S.Card key={index}>
                  <S.CardTitle>{card.title}</S.CardTitle>
                  <S.List>
                    {card.items.map((item, itemIndex) => (
                      <S.ListItem key={itemIndex}>
                        <S.Arrow src={arrow} alt="Arrow" />
                        {item}
                      </S.ListItem>
                    ))}
                  </S.List>
                  <p>
                    <strong>{props.values.moreText}</strong>
                  </p>
                </S.Card>
              ))}
            </S.Divs>
            <S.DesktopLink
              href={props.urlBuilder.build(
                props.values.button?.link,
                props.params,
              )}
              onClick={handleCtaClick}
            >
              {props.values.button?.title}
            </S.DesktopLink>
            <S.MobileLink
              href={props.urlBuilder.build(
                props.values.button?.link,
                props.params,
              )}
              onClick={handleCtaClick}
            >
              {props.values.button?.title}
            </S.MobileLink>
          </S.BannerWrapper>
        </Wrapper>
      </S.BannerContainer>
    </S.Container>
  );
}
